import { getegid } from "process";
import { HotelSearchParams } from "../../types";
import React, { useEffect, useState, useCallback } from "react";
import { Button, Card } from "react-bootstrap";
import { formatDate } from "../../functions/Utils";
import LoadingMessage from "../LoadingMessage";
import { FaCity } from "react-icons/fa6";

interface Props {
  params: HotelSearchParams;
}

const HotelSearchCard: React.FC<Props> = ({ params }) => {
  const [offers, setOffers] = useState<[]>([]);
  const [nb_offers, setNbOffers] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const {
    location,
    checkin_date,
    checkout_date,
    number_adults = 1,
    number_children = 0,
    number_rooms = 1,
  } = params;


  const bookingParams = new URLSearchParams({
    ss: location.cityname,
    checkin: checkin_date,
    checkout: checkout_date,
    group_adults: number_adults=== null ? "0" : number_adults.toString(),
    group_children: number_children===null ? "0" :  number_children.toString(),
    no_rooms: number_rooms===null ? "0" : number_rooms.toString(),
  });

  const bookingUrl = `https://www.booking.com/searchresults.html?${bookingParams.toString()}`;



  const fetchHotels = useCallback(async () => {
    setLoading(true);
    setError(null);
    setOffers([]);

    try{

    } catch (err) {
        setError("Une erreur est survenue lors de la recherche d'hotels.");
    } finally {
      setLoading(false);
    }
  }, [params])


  useEffect(() => {
      fetchHotels();
    }, [fetchHotels]);

  return (
    <Card className="my-4 border-0 bg-light rounded-4">
      <Card.Body>
        <Card.Title className="text-center"></Card.Title>
        <Card.Text className="m-0 p-0">
          <div className="d-flex justify-content-between align-items-center">
            <div className="row w-100 g-1">
              {/* Deux colonnes côte à côte */}
              <div className="col">
                <div className="d-flex align-items-center p-2 border rounded mb-2">
                  {/* Picto à gauche */}
                  <div className="me-3"><FaCity size={30} /></div>
                  {/* Texte à droite */}
                  <div>
                    <div className="fw-bold">{location.cityname}</div>
                    <div className="text-muted">{formatDate(checkin_date)}</div>
                    <div className="text-muted">{formatDate(checkout_date)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <br />
        </Card.Text>

        {loading && <LoadingMessage />}

        <div className="d-flex justify-content-center">
          <Button
            variant="primary"
            href={bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            See all offers
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default HotelSearchCard;
